import { Link } from "react-router-dom";
import { Badge, Container, Rating, Text } from "rothzerg-ui";
import { productPath } from "@/lib/routes";
import type { Product } from "@/types/catalog";
import { ProductBadge } from "./ProductBadge";

type ProductCarouselProps = {
  id: string;
  title: string;
  products: Product[];
};

export function ProductCarousel({ id, title, products }: ProductCarouselProps) {
  if (!products.length) return null;

  return (
    <section id={id} className="kpc-section">
      <Container>
        <Text variant="h3" className="kpc-title">
          {title}
        </Text>
        <div className="kpc-track-wrapper">
          <div className="kpc-track">
            {products.map((product) => (
              <Link
                key={product.id}
                to={productPath(product.slug)}
                className="kpc-card"
                id={`carousel-card-${product.id}`}
              >
                <div className="kpc-card__img-wrap">
                  {product.badges?.[0] && (
                    <span className="kpc-card__badge">
                      <ProductBadge badge={product.badges[0]} />
                    </span>
                  )}
                  <img src={product.image} alt={product.title} className="kpc-card__img" />
                </div>
                <div className="kpc-card__body">
                  <span className="kpc-card__seller">
                    {product.sellerLabel ?? (product.seller === "kmart" ? "Kmart" : "Marketplace")}
                  </span>
                  <span className="kpc-card__title">{product.title}</span>
                  <div className="kpc-card__price-row">
                    <strong className="kpc-card__price">${product.price}</strong>
                    {product.wasPrice && product.wasPrice > product.price && (
                      <span className="kpc-card__was">${product.wasPrice}</span>
                    )}
                  </div>
                  {!product.inStock && (
                    <Badge variant="secondary" size="sm">Out of stock</Badge>
                  )}
                  {product.rating != null && (
                    <Rating value={product.rating} readOnly size="sm" />
                  )}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
